<!-- Contact Form -->
<div class="rounded-2 topo-bg" >
  <div class="container-xl container-fluid content-space-1 content-space-md-2 px-4 px-md-8 px-lg-10 pb-10 pt-5">
    <div class="row justify-content-lg-between align-items-lg-center">
      <div *ngIf="isMobile() else desktopView" >
        <div class="col-md-10 col-lg-6 mb-5 mb-lg-0">
          <ng-container *ngTemplateOutlet="phoneAndEmailSection"></ng-container>
        </div>
          <ng-container *ngTemplateOutlet="form"></ng-container>
          <div class="col-md-10 col-lg-6 mb-9 mb-lg-0">
            <ng-container *ngTemplateOutlet="infoSide"></ng-container>
        </div>
      </div>
      <ng-template #desktopView>
        <div class="col-md-10 col-lg-6 mb-9 mb-lg-0">
          <ng-container *ngTemplateOutlet="phoneAndEmailSection"></ng-container>
          <ng-container *ngTemplateOutlet="infoSide"></ng-container>
        </div>
        <ng-container *ngTemplateOutlet="form"></ng-container>
      </ng-template>
    </div>
  </div>
</div>
<!-- End Contact Form -->
<ng-template #infoSide>
    <!-- Info -->
    <div class="border-top border-white-10 my-5" style="max-width: 35rem;"></div>

    <!-- Blockquote -->
    <figure>
      <div class="mb-4">
        <img class="small-logo mr-3" src="../assets/svg/kopa-branding/full-logo-no-words.svg" alt="Logo">
        <img class="small-logo" src="../assets/svg/kopa-branding/Web_Text.svg"
             alt="Kopa Tours" >
      </div>

      <blockquote class="blockquote"><helpers-quotation-mark></helpers-quotation-mark> I've never seen a company work so hard to make their clients happy as Kopa from the very beginning to the very end.</blockquote>

      <figcaption>
        <div class="d-flex align-items-center">
          <div class="flex-grow-1 ms-3">
            <span class="ericFont">Levi F.</span><br>
            <span class="ericDesc">Summited Mount Kilimanjaro with Kopa Tours</span>
          </div>
        </div>
      </figcaption>
    </figure>
</ng-template>
<ng-template #form>
  <div class="col-lg-6 my-10 mobileMargin">
    <!-- Card -->
    <div class="card card-lg">
      <div class="card-body">
        <div class="mb-4">
          <h2 class="card-title">Fill out the form and we'll be in touch to help book your trip or answer your questions within 24 hours.</h2>
        </div>

        <!-- Form -->
        <form [formGroup]="contactForm">
          <div class="row gx-3">
            <div class="col-sm-6">
              <!-- Form -->
              <div class="mb-3">
                <label class="form-label visually-hidden" for="firstName">First name</label>
                <input type="text" class="form-control form-control-lg" name="firstName" id="firstName" placeholder="First name" aria-label="First name" formControlName="firstName" required>
              </div>
              <!-- End Form -->
            </div>
            <!-- End Col -->

            <div class="col-sm-6">
              <!-- Form -->
              <div class="mb-3">
                <label class="form-label visually-hidden" for="lastName">Last name</label>
                <input type="text" class="form-control form-control-lg" name="lastName" id="lastName" placeholder="Last name" aria-label="Last name" formControlName="lastName" required>
              </div>
              <!-- End Form -->
            </div>
            <!-- End Col -->
          </div>
          <!-- End Row -->

          <div class="row gx-3">
            <div class="col-sm-12">
              <!-- Form -->
              <div class="mb-3">
                <label class="form-label visually-hidden" for="email">Email address</label>
                <input type="email" class="form-control form-control-lg" name="email" id="email" placeholder="Email Address" aria-label="Email Address" formControlName="email" required>
              </div>
              <!-- End Form -->
            </div>
            <!-- End Col -->
            <!-- End Col -->
          </div>
          <!-- End Row -->

          <!-- Form -->
          <div class="mb-3">
            <label class="form-label visually-hidden" for="message">Message</label>
            <textarea class="form-control form-control-lg" name="message" id="message" placeholder="How can we help you?" aria-label="How can we help you?" rows="4" formControlName="message" required></textarea>
          </div>
          <!-- End Form -->

          <!-- Check -->
          <div class="form-check small mb-4">
            <input type="checkbox" class="form-check-input" id="signupFormPrivacyCheckEg2" name="optIn" data-msg="Please accept our Privacy Policy." formControlName="optIn">
            <label class="form-check-label" for="signupFormPrivacyCheckEg2"> Yes, I'd like to receive occasional marketing emails from Kopa Tours. I have the right to opt out at any time. <a class="link" routerLink="/helpful-information/privacy-policy">View privacy policy.</a></label>
          </div>
          <!-- End Check -->

          <div class="d-grid">
            <button class="btn btn-primary btn-lg btn-wide transition-3d-hover" (click)="submitForm()" [disabled]="!isFormFilled() || success">Submit
              <app-fa-icon *ngIf="!submitting && !success" iconName="chevron-right" width="1" height="1.3"></app-fa-icon>
              <span *ngIf="submitting" class="spinner-border" role="status"><span class="sr-only text-white">Loading...</span></span>
              <app-fa-icon *ngIf="success" iconName="check" width="1" height="1.3"></app-fa-icon>
            </button>
            <p *ngIf="success" class="d-inline ml-3"><br *ngIf="isMobile()"><br *ngIf="isMobile()">Your question has been submitted!</p>
          </div>
        </form>
        <!-- End Form -->
      </div>
    </div>
    <!-- End Card -->
  </div>
</ng-template>

<ng-template #phoneAndEmailSection>
  <h1 class="text-white respText">Climb Out In Front</h1>
  <p class="text-white mb-0">The Kopa Crew does what's needed to keep you ahead of the rest.</p><br *ngIf="isMobile()">
  <p class="text-white">Award-winning service, world-class care, and mountaineering excellence.</p>

  <!-- End Info -->

  <div class="row mt-5">
    <div class="col-sm-5">
      <h5 class="mb-1">Call us:</h5>
      <h3 class="infoResp"><app-fa-icon iconName="phone" class="mr-2"></app-fa-icon> 1-866-816-5672 </h3>
    </div>
    <!-- End Col -->

    <div class="col-sm-7">
      <h5 class="mb-1">Email us:</h5>
      <h3 class="infoResp"><app-fa-icon iconName="envelope" class="mr-3"></app-fa-icon><a class="link" href="mailto:contact@kopatours.com" >contact@kopatours.com</a></h3>
    </div>
    <!-- End Col -->
  </div>
</ng-template>
